
import { createContext } from 'react';
import type { AuthContextValue } from '../types';

/**
 * Auth Context
 * 
 * Provides authentication state and actions throughout the app.
 * 
 * @example
 * ```tsx
 * import { useAuth } from '~/services/auth';
 * 
 * function MyComponent() {
 *   const { user, isAuthenticated, logout } = useAuth();
 *   
 *   if (!isAuthenticated) {
 *     return <LoginForm />;
 *   }
 *   
 *   return <div>Welcome, {user.firstName}!</div>;
 * }
 * ```
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

AuthContext.displayName = 'AuthContext';
